.svg{width:60rem}.svg .bead{cursor:pointer}
/*# sourceMappingURL=abacus.component-G2RHYHGZ.css.map */
